import { connect } from 'react-redux';
import View from './AccountsStepView';
import { viewIdSelector } from './AccountsStepSelector';
import {
  data2,
  iterator,
  currentClientIdOrDefaultSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../../AccountsWorkflowConstants';
import { fetchDataIfNecessary } from '../../../AdvWorkflow/AdvWorkflowCacheActions';
import dirtyNodesMapSelector from '../../../AdvWorkflow/AdvWorkflowCacheSelector';

const mapStateToProps = (state, ownProps) => ({
  viewId: viewIdSelector(state, ownProps),
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  hasYourFamilyStartedSaving: data2(state, ownProps)(`${BACKEND_KEY}.HasYourFamilyStartedSaving`),
  alreadyHasYourFamilyStartedSavingData: data2(state, ownProps)(`${BACKEND_KEY}.AlreadyHasYourFamilyStartedSavingData`),
  dirtyNodesMap: dirtyNodesMapSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchData: (workflowId, clientId, dirtyNodesMap) => {
    dispatch(fetchDataIfNecessary(
      workflowId,
      clientId,
      [BACKEND_KEY, 'AccountTypes', 'AccountOwners'],
      dirtyNodesMap,
      false,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
